/*
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Type} from '@angular/core';
import {LoadingButton} from './loading-button';

export const /** @type {?} */ LOADING_BUTTON_DIRECTIVES: Type<any>[] = [LoadingButton];